/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7 6.99988L7 16.9999M17 6.99988V16.9999"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 10.9999L2 12.9999M12 2.99988L12 20.9999M22 10.9999V12.9999"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M7 7L7 17M2 11L2 13M12 3L12 21M17 7V17M22 11V13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M7 6.99976L7 16.9998M2 10.9998L2 12.9998M12 2.99976L12 20.9998M17 6.99976V16.9998M22 10.9998V12.9998"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M7 6.99988L7 16.9999M2 10.9999L2 12.9999M12 2.99988L12 9.99988M12 20.9999V13.9999M17 6.99988V16.9999M22 10.9999V12.9999"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7 6.99988L7 16.9999M2 10.9999L2 12.9999M12 2.99988L12 20.9999M17 6.99988V16.9999M22 10.9999V12.9999"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M7 7L7 17M2 11L2 13M12 3L12 21M17 7V17M22 11V13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
